<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="420px"
      :before-close="handleClose"
    >
      <el-form size="small" class="form-centent">
        <div class="row">
          <div class="tip"><span class="weight">*</span>节假日名称</div>
          <div class="value">
            <el-input
              v-model="formIn.holidaysFestivalsName"
              maxlength="50"
              placeholder="请输入"
              size="small"
            />
          </div>
        </div>
        <div class="row">
          <div class="tip"><span class="weight">*</span>选择日期</div>
          <div class="value">
            <el-date-picker
              v-model="holidaysFestivalsTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitUpload()">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "dayjs";
import { updateFestivals } from "@/api/platform/index.js";

export default {
  components: {},

  data() {
    return {
      dialogVisible: false,

      rowData: null,

      holidaysFestivalsTime: "",

      formIn: {
        holidaysFestivalsName: "",
        holidaysFestivalsStartTime: "",
        holidaysFestivalsEndTime: "",
      },

      pickerOptions: {
        disabledDate(time) {
          const yea = dayjs(Date.now()).subtract(1, "day").toDate();
          return time.getTime() < yea.getTime();
        },
      },
    };
  },
  computed: {
    title() {
      return this.rowData ? "编辑" : "新增";
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },

    submitUpload() {
      if (!this.formIn.holidaysFestivalsName) {
        this.$message.warning("请输入节假日名称");
        return;
      }
      if (!this.holidaysFestivalsTime) {
        this.$message.warning("请选择节假日");
        return;
      }

      let data = {};

      this.formIn.holidaysFestivalsStartTime = dayjs(
        this.holidaysFestivalsTime[0]
      ).format("YYYY-MM-DD");
      this.formIn.holidaysFestivalsEndTime = dayjs(
        this.holidaysFestivalsTime[1]
      ).format("YYYY-MM-DD");

      _.merge(data, this.formIn);

      if (this.rowData) {
        data.id = this.rowData.id;
      }

      updateFestivals(data).then((res) => {
        if (res) {
          this.$message.success("保存成功");
          this.dialogVisible = false;

          this.$emit("update");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    clear() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
      this.holidaysFestivalsTime = "";

      this.rowData = null;
    },
    open(item) {
      this.clear();
      this.dialogVisible = true;

      if (item) {
        this.rowData = _.cloneDeep(item);

        this.initViews();
      }
    },
    initViews() {
      if (this.rowData) {
        for (let key in this.rowData) {
          if (this.formIn.hasOwnProperty(key)) {
            this.formIn[key] = this.rowData[key];
          }
        }

        if (
          this.rowData.holidaysFestivalsStartTime &&
          this.rowData.holidaysFestivalsEndTime
        ) {
          let d1 = dayjs(this.rowData.holidaysFestivalsStartTime).toDate();
          let d2 = dayjs(this.rowData.holidaysFestivalsEndTime).toDate();

          this.holidaysFestivalsTime = [d1, d2];
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.form-centent {
  .row {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .tip {
      width: 6em;

      .weight {
        color: #f00;
      }
    }

    .value {
      width: 240px;
      margin-left: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>
